export const messages = {
  label: {
    id: 'admin/promotions.form.regular.editor.benefit.loyalty.status.label',
  },
  invoiced: {
    id: 'admin/promotions.form.regular.editor.benefit.loyalty.status.invoiced',
  },
  paymentApproved: {
    id: 'admin/promotions.form.regular.editor.benefit.loyalty.status.payment-approved',
  },
  view: {
    invoiced: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty.status.invoiced',
    },
    paymentApproved: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty.status.payment-approved',
    },
  },
}
